export enum ComparisonTableTabs {
  Materials = 'materials',
  Selected = 'selected',
}
